// Shared layout constants for the Prediction tab's "one look" composition.
//
// The tab sits in a content pane the left rail narrows, so a *viewport* media query would
// mis-fire (the pane is ~250px narrower than the window). Instead the hero + the two-column
// grid respond to the CONTENT-PANE width via a CSS container query. `ScoringAndRecommendations`
// establishes the container (`container-type: inline-size; container-name`); the hero + grid
// read the same `@container` name + threshold so they always flip together.

/** Container name the prediction surface establishes + queries against. */
export const PREDICTION_CONTAINER = "pbj-prediction";

/**
 * Container width (px) at/above which the hero shows its 3 zones in a row AND the "one look"
 * grid shows 2 columns; below it, both stack (gauge on top / Why above How). ~820px keeps a
 * comfortable multi-column layout at laptop widths and stacks on tablet.
 */
export const PREDICTION_MULTICOL_MIN = 820;

/** Ready-made `@container` query key for the `sx` prop (multi-column and up). */
export const PREDICTION_MULTICOL_QUERY = `@container ${PREDICTION_CONTAINER} (min-width: ${PREDICTION_MULTICOL_MIN}px)`;

/**
 * Minimum point lift (over the current score) for a plan to count as an "active projection".
 * Below this the plan adds no meaningful points, so the hero suppresses the score lead's
 * "→ with-plan" projection rather than drawing a projection indistinguishable from "now".
 */
export const MIN_PLAN_LIFT_POINTS = 0.5;
